const breadCrumbsTemplate = `
<div  class="internal-breadcrumbs">
	<ol class="breadcrumb">
	    <li><a ui-sref="login">Home</a></li>
	    <li class="active">{{page}}</li>
	</ol>
</div>
`;
export default breadCrumbsTemplate;
